import { ApiClient, ApiModelPortfolioUsage } from '@/api/_legacy/generated-api'
import { CheckboxAccordion, Currency, Space } from '@/components/core-v2'

import { StyledHeaderBlock } from './styles'
import { mapClientData } from './utilities'

type Props = {
  allowedBusinessUnitIds: string[]
  clients: ApiClient[]
  onChange: (ids: string[], value: boolean) => void
  readonlyAccess: boolean
  usages: ApiModelPortfolioUsage
}

export const PortfolioRestrictions = ({
  allowedBusinessUnitIds,
  clients,
  onChange,
  readonlyAccess,
  usages
}: Props) => {
  const CheckboxAccordionData = mapClientData(clients, usages, allowedBusinessUnitIds)

  const handleOnChange = (ids: string[], value: boolean) => {
    // When a parent ID is selected, add all children IDs to the list to be saved
    const allChildrenIds = CheckboxAccordionData.filter(client => ids.includes(client.id)).flatMap(
      client => client.children?.map(bu => bu.id) || []
    )
    const allIds = [...ids, ...allChildrenIds]
    onChange(allIds, value)
  }

  return (
    <Space py={6}>
      <Space mb={3}>
        <StyledHeaderBlock>
          <Space
            isflex
            fontSize="13px"
            fontWeight="400"
            justifyContent="space-between"
            pb={4}
            px={4}
          >
            <Space isflex alignItems="end" flexBasis="70%">
              Name
            </Space>
            <Space isflex alignItems="end" flexBasis="30%">
              <Space ml="auto">
                Value (<Currency value={usages === null ? 0 : usages.totalValue} />)
              </Space>
            </Space>
          </Space>
        </StyledHeaderBlock>
      </Space>
      <CheckboxAccordion
        data={CheckboxAccordionData}
        isReadOnly={readonlyAccess}
        onChange={handleOnChange}
      />
    </Space>
  )
}
